angular.module('elogbooksControllers').controller('SiteContactChannelsController', function (
    $rootScope,
    $scope,
    $state,
    apiClient,
    messenger,
    lodash,
    contactInformationService,
    contactInformationResponse,
    userManager,
    confirmationModal
) {
    // This controller works on a copy of contact information fields
    //  so the front-end won't get updated until the user will press Update
    $scope.contactInformation = contactInformationResponse.getData();

    $scope.previousStateSref = $rootScope.previousStateSref || $scope.previousStateSref;
    $scope.contactInformationFields = contactInformationService.sortFieldsByType(
        lodash.map($scope.contactInformation.fields || [], lodash.clone)
    );

    $scope.newRow = function () {
        $scope.contactInformationFields.push({
            type: "",
            value: "",
            notes: ""
        })
    }

    $scope.delete = function (key) {
        $scope.contactInformationFields.splice(key, 1);
        $scope.contactInformationFields = contactInformationService.sortFieldsByType(
            lodash.map($scope.contactInformationFields, lodash.clone)
        );
    }

    $scope.$watch('[contactInformationFields,contactInformation]', function () {
        if (! lodash.isEqual($scope.contactInformationFields,  $scope.contactInformation.fields)) {
            $scope.allowUpdate = true;
        } else {
            $scope.allowUpdate = false;
        }
    }, true);

    $scope.save = function () {
        $scope.contactInformationFields = contactInformationService.sortFieldsByType(
            lodash.map($scope.contactInformationFields, lodash.clone)
        );
        $scope.contactInformation.fields = contactInformationService.sortFieldsByType(
            lodash.map($scope.contactInformationFields, lodash.clone)
        );

        var primaryEmail = lodash.find($scope.contactInformationFields, { type: 'email' });
        var selfHref = contactInformationResponse.getLink('self');
        // Only run the duplicate-email check when editing a user's contact information
        var userIdMatch = selfHref.match(/\/users\/(\d+)\/contactinformation/);
        var editedUserId = userIdMatch ? userIdMatch[1] : null;

        if (primaryEmail && primaryEmail.value && userIdMatch) {
            apiClient.get(userManager.user.getLink('check-email'), { email: primaryEmail.value, userId: editedUserId }).then(function (response) {
                if (response && response.emailInUse) {
                    return confirmationModal.open({
                        titleMessage: 'ARE_YOU_SURE',
                        bodyMessage: 'SSO_EMAIL_MATCH_SHARED_EMAIL_WARNING',
                        primaryText: 'CONTINUE',
                        primaryClass: 'btn-warning',
                        secondaryText: 'CANCEL',
                        secondaryClass: 'btn-default'
                    }).result.then(function () {
                        doSave();
                    }).catch(angular.noop)
                    .finally(function () {
                        $scope.allowUpdate = true;
                    })
                } else {
                    doSave();
                }

                $scope.allowUpdate = true;
            });
        } else {
            doSave();
        }
    }

    function doSave() {
        apiClient.update(contactInformationResponse.getLink('self'), angular.copy($scope.contactInformation)).then(function (response) {
            if (!response) {
                messenger.error('There was a problem with your request');
            } else if ($rootScope.previousState !== '') {
                $state.go($rootScope.previousState, $rootScope.previousStateParams).then(function () {
                    messenger.success('Contact Information updated');
                });
            }
        });
    }
});
